module.exports = __webpack_public_path__ + "static/infante-971b95ce56abefa345b94eccc01ea3cd.jpg";